import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Order.sass';
import {
  setQuotingMapLocation1,
  setQuotingMapLocation2,
} from '../../actions/quoting';

class autoComplete extends React.Component {
  static propTypes = {
    suggestion: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        id: PropTypes.string,
      }),
    ),
    index: PropTypes.number.isRequired,
    onClickSelectSuggestion: PropTypes.func.isRequired,
  };

  static defaultProps = {
    suggestion: [],
  };

  constructor(props) {
    super(props);
    this.onClickLocationName = this.onClickLocationName.bind(this);
  }

  onClickLocationName(location) {
    this.props.onClickSelectSuggestion(
      {
        description: location.description,
        place_id: location.place_id,
      },
      this.props.index,
    );
  }

  render() {
    if (this.props.suggestion.length <= 0) {
      return '';
    }
    return (
      <ul role="menu" className={`${s.suggestionContainer}`}>
        {this.props.suggestion.map((i, index) => (
          <li key={index.toString()} className={`${s.suggestionItem}`}>
            <span
              role="button"
              tabIndex={0}
              onClick={() => {
                this.onClickLocationName(i);
              }}
              onKeyPress={() => {}}
              className={`${s.suggestionSpan}`}
            >
              {i.description}
            </span>
          </li>
        ))}
      </ul>
    );
  }
}
const mapState = state => ({
  address1: state.quoting.address1,
  address2: state.quoting.address2,
});

const mapDispatch = {
  setQuotingMapLocation1,
  setQuotingMapLocation2,
};

export default connect(mapState, mapDispatch)(withStyles(s)(autoComplete));



// WEBPACK FOOTER //
// ./src/routes/order/autoComplete.js